import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Table, Spinner } from 'react-bootstrap';
import { legalAttendanceReport } from '../../requests/legalreports';
import AttendanceProofRender from './AttendanceProofRender';

const AttendanceFilterDataTable = ({ customParams }) => {
  const [attendances, setAttendances] = useState([]);
  const [onRequest, setOnRequest] = useState(true);
  const isMounted = useRef(true);
  const hasFetched = useRef(false);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleAttendanceReportRequest = useCallback(() => {
    setOnRequest(true);
    legalAttendanceReport({
      dispatch,
      params: { ...customParams },
      successCallback: response => {
        if (isMounted.current) {
          setAttendances(response.data);
          setOnRequest(false);
        }
      }
    });
  }, [customParams, dispatch]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    handleAttendanceReportRequest();
  }, [handleAttendanceReportRequest]);

  const renderResult = (attendance, index) => {
    return (
      <tr key={attendance.id || index}>
        <td className="text-center align-middle">{attendance.date}</td>
        <td className="text-center align-middle">{attendance.attendance}</td>
        <td className="text-center align-middle">{attendance.absence}</td>
        <td className="text-center align-middle">
          {attendance.justification}
          {<AttendanceProofRender item={{ ...attendance, justification: '' }} />}
        </td>
      </tr>
    );
  };

  const tableHeader = () => {
    return ['FECHA', 'ASISTENCIA', 'AUSENCIA', 'OBSERVACIONES'];
  };

  const renderData = () => {
    if (onRequest) {
      return (
        <div className="containerSpinnerLoad position-absolute h-100 w-100">
          <Spinner animation="border" variant="primary" />
        </div>
      );
    }

    if (attendances.length === 0) {
      return (
        <div className="text-center pt-3 pb-3">
          <p className="text-muted" style={{ fontFamily: 'Arial', fontSize: '8px' }}>
            No hay trabajadores que coincidan con la selección
          </p>
        </div>
      );
    }

    return (
      <>
        <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
          <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
            <tr className="rdt_TableCol">
              {tableHeader().map(itemHeader => (
                <th className="text-center align-middle" key={itemHeader}>
                  {itemHeader}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{attendances.map((attendance, index) => renderResult(attendance, index))}</tbody>
        </Table>
      </>
    );
  };

  return <>{renderData()}</>;
};

export default AttendanceFilterDataTable;
